import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
	selector: 'app-button',
	templateUrl: './button.component.html',
	styleUrls: ['./button.component.scss']
})
export class ButtonComponent {
	@Input() buttonText = '';
	@Input() isDisabled = false;
	@Input() isOutlined = false;
	@Input() hasIcon = false;
	@Input() iconName = '';
	@Input() isBig = false;
	@Input() isSmall = false;
	@Input() type = '';
	@Input() color = 'primary';
	@Input() iconBtn = false;
	@Input() bold = false;

	@Output() btnClick = new EventEmitter();
	@Output() btnBlur = new EventEmitter();

	get name(): string {
		return this.buttonText;
	}

	onClick() {
		this.btnClick.emit();
	}

	onBlur() {
		this.btnBlur.emit();
	}
}
